/// <reference path="../../../../../rcwebmodels/reeferformatter.cs.d.ts" />
import * as React from 'react';
import { AgGridReact } from 'ag-grid-react';
import Select from 'react-select';
import "./../../../node_modules/react-select/dist/react-select.css"
//import Bing from '../../actions/ReeferMap.js';
//import * as ReeferMapjs from '../../actions/ReeferMap.js';
//var Bing = ReeferMapjs.default;
import * as Exceljs from '../../actions/ExportToExcel.js';
import Formatters from '../../actions/Formatters';
import ReeferFormatters from '../../actions/ReeferFormatter';
import { ReeferCellRenderer } from '../../actions/ReeferCellRenderer';
import $ from 'jquery';
//import * as moment from 'moment';
import moment from 'moment';
import DateFormat from 'dateformat';
import { RCUtils } from './../../RCUtils';
import { GridPTIToolBar } from '../sharedcomponents/GridPTIToolBar';
//import { DateTime } from 'react-datetime-bootstrap';
import DatePicker from 'react-datepicker'; 
// pull in the ag-grid styles we're interested in
import '../../../node_modules/ag-grid-community/dist/styles/ag-grid.css';
import '../../../node_modules/ag-grid-community/dist/styles/ag-theme-fresh.css';
import { PopupWindow } from '../sharedcomponents/PopupWindow';
import { ReeferStatusGrid } from '../childcomponents/ReeferStatusGrid';
//import { GridPreferenceControl } from './../sharedcomponents/GridPreferenceControl';
import { GridColumnPreferences } from './../sharedcomponents/GridColumnPreferences';
import { GridPreferenceControl } from './../sharedcomponents/GridPreferenceControl';
import UserRights from '../../actions/UserRights';

var Excel = Exceljs.default;
var Config: any = require('../../Config.json');

interface PTResultGridState {
    loading: boolean;
    rowData: server.USP_GetPTResults[];
    Filters: server.PTResultFilters;
    columnDefs: any[];
    overlayLoadingTemplate: any;
    pageSize: any;
    gridApiParams: any;
    reeferFormatter: server.ReeferFormatter;
    buttonState: boolean;
    PreferenceDTTM: any;
    dropDownVCInfo: server.VesselInformation[];
    dropDownGeoInfo: server.GeofenceData[];
    selectedVesselID: number;
    selectedGoeID: number;
    selectedGoeTag: string;
    isClearable: boolean;
    PTReport: string;
    ReportReeferId: string;
    modelTitleReport: string;
    popUpHtmlReport: any;
    modelTitle: string;
    popUpHtml: any;
    rowGroupPanelShow: string;
    groupDefaultExpanded: number;
    autoGroupColumnDef: any;
    TWReport: string;
}
var self;
var customerTypeCd;
var custId;
var coppiedData;
var currentMousePos = { x: -1, y: -1 };
var columnDefs2;
var functionId;
export class PTResultGrid extends React.Component<any, PTResultGridState> {
    constructor(props: any) {
        super(props);
        //var userData = JSON.parse(JSON.stringify(this.props.loggedInUserData));
        customerTypeCd = JSON.parse(sessionStorage.getItem('customerDetails')).CustomerTypeCd;//this.props.loggedInUserData.User.Customer.CustomerTypeCd;
        custId = JSON.parse(sessionStorage.getItem('customerDetails')).CustomerId;//this.props.loggedInUserData.User.Customer.CustomerId;
        var filterSet = this.setDefaultFilters();
        var overlayTemplate = '<span class="ag-overlay-loading-center">Loading...</span>';
        var currentUtcDttm = moment(new Date(new Date().toUTCString()).toISOString(), 'YYYY-MM-DDTHH:mm:ss');
        var columnDefs = this.createColumnDefs();
        this.state = {
            loading: true,
            rowData: [],
            columnDefs: columnDefs,
            overlayLoadingTemplate: overlayTemplate,
            Filters: filterSet,
            pageSize: 25,
            gridApiParams: [],
            reeferFormatter: this.props.propsReeferFormatterData,
            buttonState: false,
            PreferenceDTTM: Formatters.DateTimeFormatter(currentUtcDttm),
            dropDownVCInfo: [],
            dropDownGeoInfo: [],
            selectedVesselID: 0,
            selectedGoeID: 0,
            selectedGoeTag: null,
            isClearable: true,
            PTReport: '',
            ReportReeferId: '',
            modelTitleReport: '',
            popUpHtmlReport: '',
            modelTitle: '',
            popUpHtml: '',
            rowGroupPanelShow: 'always',
            groupDefaultExpanded: -1,
            autoGroupColumnDef: { minWidth: 200 },
            TWReport: ''
        };
        functionId = 66; // functionId for PTResults Grid
        self = this;
    }

    setDefaultFilters() {
        var filters: server.PTResultFilters = {
            FromDate: null, ToDate: null,//RCNG-3323
            GeofenceTag: null, VesselID: null, GeofenceHistoryUserDataID: null, CustomerID: null, CustomerTypeCd: null, AssetState: null
        };
        return filters;
    }

    componentDidMount() {
        //columnDefs2 = this.createColumnDefs();
        //var customColDefs = this.createColumnDefs();
        //var customChild = customColDefs[0].children.filter(x => x.headerName != "TW" && x.headerName != "TW Time");
        //columnDefs2 = [{ headerName: "", children: customChild }];
       
       
        
        
        //Excel.draggableModalPopup(document.getElementById("contextMenuModel-PTR"));
        Excel.preventDefault();
        this.renderDateFields();
        this.loadData();
        self.enableDisableSearchButton(false);
        //$('#PTR-grid .ag-column-hover').contextmenu(function (e) {
        //    var relX = e.pageX - $('#PTR-grid .ag-column-hover').offset().left;
        //    var relY = e.pageY - $('#PTR-grid .ag-column-hover').offset().top;
        //    //$(".context-menu-PTR").toggle(100).css({
        //    //    top: relY + 12,
        //    //    left: relX + 10
        //    //});
        //    var relativeY = 120;
        //    var relativeX = 120;
        //    $(".context-menu-PTR").css({
        //        top: relativeY + "px",
        //        left: relativeX + "px",
        //        position: "absolute"
        //    });

        //    $("#contextmenu-PTR").hide();
        //    e.preventDefault();
        //});
        //$(document).mousemove(function (event) {
        //    currentMousePos.x = event.pageX;
        //    currentMousePos.y = event.pageY;
        //    event.preventDefault();
        //});
        //var reeferStatusGridRowsCount = this.props.getReeferStatusGridRows;
        //if (reeferStatusGridRowsCount > 0) {
        //    $('#liShowinReeferGrid').removeClass('disabled');
        //    $('#liShowinReeferGrid').addClass('enabled');
        //} else {
        //    $('#liShowinReeferGrid').removeClass('enabled');
        //    $('#liShowinReeferGrid').addClass('disabled');
        //}
    }
    
    onGridReady(params: any) {
        //$('#globalLoader').show();
        params.api.showLoadingOverlay();
        //params.api.gridOptionsWrapper.gridOptions.suppressContextMenu = true;
        var gridPreferencesData: any = self.props.dashboardWidgetsSearch.filter(x=>x.DashboardWidgetId == 8);
        self.setState({ gridApiParams: params.api });
        var defaultColumns = params.api.gridOptionsWrapper.gridOptions.columnApi.getAllGridColumns();
        params.api.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(defaultColumns, false);
        //$('#globalLoader').hide();
        GridColumnPreferences.StatusGridPreferenceColumns(functionId, params.api, gridPreferencesData, "PTResultGrid");
    }

    static refreshGridReady(dashboardWidgetsSearch: any){
        var gridPreferencesData: any = dashboardWidgetsSearch.filter(x=>x.DashboardWidgetId == 8);
        var defaultColumns = self.state.gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getAllGridColumns();
        self.state.gridApiParams.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(defaultColumns, false);
        setTimeout(() => {
            GridColumnPreferences.StatusGridPreferenceColumns(functionId, self.state.gridApiParams, gridPreferencesData, "PTResultGrid");
        }, 3000);       
    }

    showGridPreferenceColumns() {
        var gridApi = self.state.gridApiParams;
        var gridPreferencesData: any = self.props.dashboardWidgetsSearch.filter(x=>x.DashboardWidgetId == 8);
        var defaultColumns = gridApi.gridOptionsWrapper.gridOptions.columnApi.getAllGridColumns();
        gridApi.gridOptionsWrapper.gridOptions.columnApi.setColumnsVisible(defaultColumns, false);
        $('#globalLoader').hide();
        GridColumnPreferences.StatusGridPreferenceColumns(functionId, gridApi, gridPreferencesData, "PTResultGrid");
    }

    refreshGrid = () => {
        self.state.gridApiParams.showLoadingOverlay();
        this.loadData();
    };

    static RefreshPTResultsGrid() {
        if (self != null && self != undefined) {
            self.state.gridApiParams.showLoadingOverlay();
            self.loadData();
        }
    }

    getPTResultDetails() {
        var filters = this.state.Filters;
        var message = this.ValidateHistoryDates(filters);
        if (message != "") {
            PopupWindow.showErrorMessage("Alert", message);
            return;
        }
        else {
            this.setState({ Filters: filters });
        }
        self.state.gridApiParams.showLoadingOverlay();
        this.loadData();
        $('#PTRPopUP').removeClass('show');
    }

    static ClearHistoryGridData() {


        self.setState({
            rowData: [],
            loading: false
        });

        self.enableDisableSearchButton(false);
    }

    static refreshDataGrid() {
        self.setState({
            rowData: self.state.rowData
        });
    };

    enableDisableSearchButton(isEnable: any) {
        if (isEnable) {
            this.setState({ buttonState: true });
        }
        else {
            this.setState({ buttonState: false });
        }
    }

    createColumnDefs() {
        var GeofenceType = JSON.parse(sessionStorage.getItem('UserInfo')).CustomerFenceTypeCd;
        if (GeofenceType == "B") {
            return [    
                {
                    headerName: 'Group',
                    minWidth: 210,
                    hide: true
                },
                {
                    headerName: '',
                    children: [
                        {
                            headerName: "Reefer ID", field: "ReeferID", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                            valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.ReeferID); },
                            cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 140, onCellClicked: this.onCellClickedCopy.bind(this)
                        },
                        {
                            headerName: "PTI", field: "PTResult", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                            valueGetter: (params) => { return ReeferFormatters.PTResultSorting(params); },
                            tooltip: Formatters.toolTipFormatter, cellRenderer: ReeferCellRenderer.PreTripFormatter, width: 55, onCellClicked: this.onCellClickedCopy.bind(this)
                        },
                        {
                            headerName: "PTI Type", field: "PTIType", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                            valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.PTIType); },
                            cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 90, onCellClicked: this.onCellClickedCopy.bind(this)
                        },
                        {
                            headerName: "PTI time", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                            headerValueGetter: Formatters.TimeZoneHeaderFormatter, field: "PTRDateTime", cellRenderer: Formatters.dateTypeFormatter, width: 150,
                            filterParams: { valueGetter: params => { return Formatters.dateTypeFormatterPTRDateTimeForFilter(params); } }, onCellClicked: this.onCellClickedCopy.bind(this)
                        },
                        {
                            headerName: "OEM PTI state", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, field: "TWState",
                            valueGetter: (params) => { return Formatters.TripWiseSorting(params); },
                            filterParams: { valueGetter: params => { return Formatters.TwStateForFilter(params); } },
                            cellRenderer: ReeferCellRenderer.TripWiseFormatter, width: 50, onCellClicked: this.onCellClickedCopy.bind(this)
                        },
                        {
                            headerName: "OEM PTI time", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                            headerValueGetter: Formatters.TimeZoneHeaderFormatter, field: "TWTime", cellRenderer: Formatters.dateTypeFormatter, width: 150,
                            filterParams: { valueGetter: params => { return Formatters.dateTypeFormatterTWTimeForFilter(params); } }, onCellClicked: this.onCellClickedCopy.bind(this)
                        },
                        {
                            headerName: "Geofence", field: "ServerGeofence", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                            valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.ServerGeofence); },
                            cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this)
                        },
                        {
                            headerName: "Vessel", field: "VesselName", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                            valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.VesselName); },
                            cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this)
                        }
                    ]
                }
            ];
        }
        else if (GeofenceType == "D") {
            return [   
                {
                    headerName: 'Group',
                    minWidth: 210,
                    hide: true
                },
                {
                    headerName: '',
                    children: [
                        {
                            headerName: "Reefer ID", field: "ReeferID", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                            valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.ReeferID); },
                            cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 140, onCellClicked: this.onCellClickedCopy.bind(this)
                        },
                        {
                            headerName: "PTI", field: "PTResult", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                            valueGetter: (params) => { return ReeferFormatters.PTResultSorting(params); },
                            tooltip: Formatters.toolTipFormatter, cellRenderer: ReeferCellRenderer.PreTripFormatter, width: 55, onCellClicked: this.onCellClickedCopy.bind(this)
                        },
                        {
                            headerName: "PTI Type", field: "PTIType", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                            valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.PTIType); },
                            cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 90, onCellClicked: this.onCellClickedCopy.bind(this)
                        },
                        {
                            headerName: "PTI time", headerValueGetter: Formatters.TimeZoneHeaderFormatter, field: "PTRDateTime", enableRowGroup: true,
                            cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true, cellRenderer: Formatters.dateTypeFormatter,
                            filterParams: { valueGetter: params => { return Formatters.dateTypeFormatterPTRDateTimeForFilter(params); } }, width: 150, onCellClicked: this.onCellClickedCopy.bind(this)
                        },
                        {
                            headerName: "OEM PTI state", field: "TWState", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                            valueGetter: (params) => { return Formatters.TripWiseSorting(params); },
                            filterParams: { valueGetter: params => { return Formatters.TwStateForFilter(params); } },
                            cellRenderer: ReeferCellRenderer.TripWiseFormatter, width: 50, onCellClicked: this.onCellClickedCopy.bind(this)
                        },
                        {
                            headerName: "OEM PTI time", headerValueGetter: Formatters.TimeZoneHeaderFormatter, field: "TWTime", enableRowGroup: true, cellClass: 'myExcelStyle',
                            sortable: true, filter: true, resizable: true, cellRenderer: Formatters.dateTypeFormatter, width: 150,
                            filterParams: { valueGetter: params => { return Formatters.dateTypeFormatterTWTimeForFilter(params); } }, onCellClicked: this.onCellClickedCopy.bind(this)
                        },
                        {
                            headerName: "Geofence", field: "DeviceGeofence", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                            valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.DeviceGeofence); },
                            cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this)
                        },
                        {
                            headerName: "Vessel", field: "VesselName", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                            valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.VesselName); },
                            cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this)
                        }
                    ]
                }
            ];
        }
        else if (GeofenceType == "S") {
            return [        
                {
                    headerName: 'Group',
                    minWidth: 210,
                    hide: true
                },
                {
                    headerName: '',
                    children: [
                        {
                            headerName: "Reefer ID", field: "ReeferID", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                            valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.ReeferID); },
                            cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 140, onCellClicked: this.onCellClickedCopy.bind(this)
                        },
                        {
                            headerName: "PTI", field: "PTResult", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                            valueGetter: (params) => { return ReeferFormatters.PTResultSorting(params); },
                            tooltip: Formatters.toolTipFormatter, cellRenderer: ReeferCellRenderer.PreTripFormatter, width: 55, onCellClicked: this.onCellClickedCopy.bind(this)
                        },
                        {
                            headerName: "PTI Type", field: "PTIType", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                            valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.PTIType); },
                            cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 90, onCellClicked: this.onCellClickedCopy.bind(this)
                        },
                        {
                            headerName: "PTI time", headerValueGetter: Formatters.TimeZoneHeaderFormatter, field: "PTRDateTime", enableRowGroup: true, cellClass: 'myExcelStyle',
                            sortable: true, filter: true, resizable: true, cellRenderer: Formatters.dateTypeFormatter, width: 150,
                            filterParams: { valueGetter: params => { return Formatters.dateTypeFormatterPTRDateTimeForFilter(params); } }, onCellClicked: this.onCellClickedCopy.bind(this)
                        },
                        {
                            headerName: "OEM PTI state", field: "TWState", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                            valueGetter: (params) => { return Formatters.TripWiseSorting(params); },
                            filterParams: { valueGetter: params => { return Formatters.TwStateForFilter(params); } },
                            cellRenderer: ReeferCellRenderer.TripWiseFormatter, width: 50, onCellClicked: this.onCellClickedCopy.bind(this)
                        },
                        {
                            headerName: "OEM PTI time", headerValueGetter: Formatters.TimeZoneHeaderFormatter, field: "TWTime", enableRowGroup: true, cellClass: 'myExcelStyle',
                            sortable: true, filter: true, resizable: true, cellRenderer: Formatters.dateTypeFormatter, width: 150,
                            filterParams: { valueGetter: params => { return Formatters.dateTypeFormatterTWTimeForFilter(params); } }, onCellClicked: this.onCellClickedCopy.bind(this)
                        },
                        {
                            headerName: "Device fence", field: "DeviceGeofence", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                            valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.DeviceGeofence); },
                            cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this)
                        },
                        {
                            headerName: "Server fence", field: "ServerGeofence", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                            valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.ServerGeofence); },
                            cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this)
                        },
                        {
                            headerName: "Vessel", field: "VesselName", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                            valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.VesselName); },
                            cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this)
                        }
                    ]
                }
            ];
        }
        else {
            return [
                {
                    headerName: 'Group',
                    minWidth: 210,
                    hide: true
                },
                {
                    headerName: '',
                    children: [
                        {
                            headerName: "Reefer ID", field: "ReeferID", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                            valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.ReeferID); },
                            cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 140, onCellClicked: this.onCellClickedCopy.bind(this)
                        },
                        {
                            headerName: "PTI", field: "PTResult", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                            valueGetter: (params) => { return ReeferFormatters.PTResultSorting(params); },
                            tooltip: Formatters.toolTipFormatter, cellRenderer: ReeferCellRenderer.PreTripFormatter, width: 55, onCellClicked: this.onCellClickedCopy.bind(this)
                        },
                        {
                            headerName: "PTI Type", field: "PTIType", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                            valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.PTIType); },
                            cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 90, onCellClicked: this.onCellClickedCopy.bind(this)
                        },
                        {
                            headerName: "PTI time", headerValueGetter: Formatters.TimeZoneHeaderFormatter, field: "PTRDateTime", enableRowGroup: true, cellClass: 'myExcelStyle',
                            sortable: true, filter: true, resizable: true, cellRenderer: Formatters.dateTypeFormatter, width: 150,
                            filterParams: { valueGetter: params => { return Formatters.dateTypeFormatterPTRDateTimeForFilter(params); } }, onCellClicked: this.onCellClickedCopy.bind(this)
                        },
                        {
                            headerName: "OEM PTI state", field: "TWState", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                            valueGetter: (params) => { return Formatters.TripWiseSorting(params); },
                            filterParams: { valueGetter: params => { return Formatters.TwStateForFilter(params); } },
                            cellRenderer: ReeferCellRenderer.TripWiseFormatter, width: 50, onCellClicked: this.onCellClickedCopy.bind(this)
                        },
                        {
                            headerName: "OEM PTI time", headerValueGetter: Formatters.TimeZoneHeaderFormatter, field: "TWTime", enableRowGroup: true, cellClass: 'myExcelStyle',
                            sortable: true, filter: true, resizable: true, cellRenderer: Formatters.dateTypeFormatter, width: 150,
                            filterParams: { valueGetter: params => { return Formatters.dateTypeFormatterTWTimeForFilter(params); } }, onCellClicked: this.onCellClickedCopy.bind(this)
                        },
                        {
                            headerName: "Geofence", field: "GeofenceTag", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                            valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.GeofenceTag); },
                            cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this)
                        },
                        {
                            headerName: "Vessel", field: "VesselName", enableRowGroup: true, cellClass: 'myExcelStyle', sortable: true, filter: true, resizable: true,
                            valueGetter: (params) => { if (params.data != null && params.data != undefined) return Formatters.stringTypeSorting(params.data.VesselName); },
                            cellRenderer: ReeferCellRenderer.StringTypeValueFormatter, width: 150, onCellClicked: this.onCellClickedCopy.bind(this)
                        }
                    ]
                }
            ];
        }
    }

    groupRowInnerRenderer(params) {

        var fieldName = params.node.field;
        var fieldValue = params.node.key;

        //var colDef = params.node.columnApi.columnController.filter(x => x.colId == fieldName);
        var columnDisplayName = params.node.rowGroupColumn.colDef.headerName;

        if (fieldValue == "-NA-" || fieldValue == "-999")
            return "*No " + columnDisplayName;

        switch (fieldName.toString().trim()) {

            case "PTResult":
                return ReeferCellRenderer.PTResultGrouping(fieldValue);
            case "TWState":
                    {
                    var ReeferOemTypeCd = null; var DimiResultActuator = null; var DimiResultAlarm = null; var DimiResultOOR = null; var DimiMode = null; var DimiResultTerm = null;var DimiResultValidity = null;
                    if (params.node.rowIndex != undefined && params.node.rowIndex != null
                        && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != undefined
                        && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != null) {
                        ReeferOemTypeCd = self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex].ReeferOemTypeCd;
                        DimiResultActuator = self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex].DimiResultActuator;
                        DimiResultAlarm = self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex].DimiResultAlarm;
                        DimiResultOOR = self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex].DimiResultOOR;
                        DimiMode = self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex].DimiMode;
                        DimiResultTerm = self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex].DimiResultTerm; //Added DimiResultTerm
                        DimiResultValidity = self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex].DimiResultValidity;
                    }
                    return ReeferCellRenderer.TripWiseGrouping(fieldValue, ReeferOemTypeCd, DimiResultActuator, DimiResultAlarm, DimiResultOOR, DimiResultTerm, DimiMode,DimiResultValidity);
                }
            case "PTRDateTime":
            case "TWTime":
                return Formatters.dateTypeGrouping(fieldValue, fieldName, params);
            default:
                return fieldValue;
        }

    }

    pageSizeChange(event: React.FormEvent<HTMLSelectElement>) {
        var pageSize = this.state.pageSize;
        var Value: string = event.currentTarget.value;
        pageSize = Value;
        self.setState({
            pageSize: pageSize
        });

        self.state.gridApiParams.paginationSetPageSize(parseInt(pageSize));
        self.state.gridApiParams.paginationGoToFirstPage();
    }

    onPaginationPageLoaded(params: any) {
        var currentpage = params.api.paginationGetCurrentPage();
        var pagesize = params.api.paginationGetPageSize();
        var rowindex = pagesize * currentpage - 1;

        var rowNode = params.api.getRowNode(rowindex + 1);
        // do something with the row, eg select it
        if (rowNode != undefined && rowNode != null)
            rowNode.setSelected(true);
    }

    navigateToNextCell(params: any) {
        var previousCell = params.previousCellDef;
        var suggestedNextCell = params.nextCellDef;

        var KEY_UP = 38;
        var KEY_DOWN = 40;
        var KEY_LEFT = 37;
        var KEY_RIGHT = 39;

        switch (params.key) {
            case KEY_DOWN:
                previousCell = params.previousCellDef;
                // set selected cell on current cell + 1
                self.state.gridApiParams.gridOptionsWrapper.gridOptions.api.forEachNode((node) => {
                    if (previousCell.rowIndex + 1 === node.rowIndex) {
                        node.setSelected(true);
                    }
                });
                return suggestedNextCell;
            case KEY_UP:
                previousCell = params.previousCellDef;
                // set selected cell on current cell - 1
                self.state.gridApiParams.gridOptionsWrapper.gridOptions.api.forEachNode((node) => {
                    if (previousCell.rowIndex - 1 === node.rowIndex) {
                        node.setSelected(true);
                    }
                });
                return suggestedNextCell;
            case KEY_LEFT:
            case KEY_RIGHT:
                return suggestedNextCell;
            default:
                throw "this will never happen, navigation is always on of the 4 keys above";
        }
    }

    ValidateHistoryDates(filters: any) {
        var currentDttm = this.state.PreferenceDTTM;
        var fromDttm = filters.FromDate;
        var toDttm = filters.ToDate;
        if (fromDttm == "Invalid date" || fromDttm == null || fromDttm == "")
            return "Invalid From Date.";

        if (toDttm == "Invalid date" || toDttm == null || toDttm == "")
            return "Invalid To Date.";

        //if (moment(new Date(fromDttm)) > moment(new Date(currentDttm)).endOf('day'))
        //    return "From date should not be greater than current date.";

        //if (moment(new Date(toDttm)) > moment(new Date(currentDttm)).endOf('day'))
        //    return "To date should not be greater than current date.";

        if (moment(new Date(fromDttm)) > moment(new Date(toDttm)))
            return "From Date should not be greater than To Date.";

        return "";
    }


    FromDateChange(date) {
        var filters = self.state.Filters;
        filters.FromDate = DateFormat(new Date(date), 'mm/dd/yyyy HH:MM');
        self.setState({ Filters: filters });
        //$('#btnReeferHistorySearch').removeAttr('disabled');
    }

    ToDateChange(date) {
        var filters = self.state.Filters;
        filters.ToDate = DateFormat(new Date(date), 'mm/dd/yyyy HH:MM');
        self.setState({ Filters: filters });
        //$('#btnReeferHistorySearch').removeAttr('disabled');
    }

    renderDateFields() {
        var currentDateFilters = this.state.Filters;
        if (currentDateFilters.ToDate != null && currentDateFilters.ToDate != undefined) {
            var toDTTM = DateFormat(new Date(currentDateFilters.ToDate), 'mm/dd/yyyy');
            var fromDTTM = DateFormat(new Date(currentDateFilters.FromDate), 'mm/dd/yyyy');
            var fromDate = moment(new Date(fromDTTM)).startOf('day').toString();
            var toDate = moment(new Date(toDTTM)).endOf('day').toString();
            currentDateFilters.FromDate = DateFormat(new Date(fromDate), 'mm/dd/yyyy HH:MM');
            currentDateFilters.ToDate = DateFormat(new Date(toDate), 'mm/dd/yyyy HH:MM');
            this.setState({ Filters: currentDateFilters });
        }
        else {
            var toDTTM = this.state.PreferenceDTTM;
            var modifiedDttm = new Date(toDTTM);
            modifiedDttm.setDate(modifiedDttm.getDate() - 29);
            var fromDTTM = DateFormat(new Date(modifiedDttm), 'mm/dd/yyyy');
            var fromDate = moment(new Date(fromDTTM)).startOf('day').toString();
            var toDate = moment(new Date(toDTTM)).endOf('day').toString();
            currentDateFilters.FromDate = DateFormat(new Date(fromDate), 'mm/dd/yyyy HH:MM');
            currentDateFilters.ToDate = DateFormat(new Date(toDate), 'mm/dd/yyyy HH:MM');
            this.setState({ Filters: currentDateFilters });
        }
    }

    loadData() {
        //var varcolumnDefs = this.createColumnDefs();
        columnDefs2 = this.createColumnDefs();
        //var customColDefs = this.createColumnDefs();
        //var customChild = customColDefs[0].children.filter(x => x.headerName != "TW" && x.headerName != "TW Time");
        //columnDefs2 = [{ headerName: "", children: customChild }];
        this.state.Filters.AssetState = this.props.assetState;
        this.state.Filters.CustomerID = custId;
        this.state.Filters.CustomerTypeCd = customerTypeCd;
        this.state.Filters.GeofenceHistoryUserDataID = this.state.selectedGoeID;
        if (this.state.selectedGoeID > 0)
            this.state.Filters.GeofenceTag = this.state.selectedGoeTag;
        else
            this.state.Filters.GeofenceTag = null;
        this.state.Filters.VesselID = this.state.selectedVesselID;
        var filterParams = JSON.stringify(this.state.Filters);

        //$("#globalLoader").show();
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/GetPTResult', { method: 'POST', body: filterParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        RCUtils.fetchRetry(request)
            .then(RCUtils.handleResponse)
            .then(response => response.json() as Promise<any>)
            .then(data => {
                self.state.gridApiParams.hideOverlay();
                if (data.PTResultsData.length == 0)// RCNG-5070 OMP QA2: "No Rows To Show" caption is not showing in all grids in dashboard
                    self.state.gridApiParams.showNoRowsOverlay();
                self.setState({
                    rowData: data.PTResultsData,
                    dropDownVCInfo: data.VesselInfoData,
                    dropDownGeoInfo: data.GeofenceInfoData,
                    //columnDefs: varcolumnDefs,//customColDefs,
                    loading: false
                });
                //$("#globalLoader").hide();
            });
    }
    /* start RCNG-16 */
    static GetPTResultsByAssetState(selectedAssetStates: any) {
        //if (selectedAssetStates == "")
        //    selectedAssetStates = "A,D,R";
        self.state.gridApiParams.showLoadingOverlay();
        self.state.Filters.AssetState = selectedAssetStates;//RCNG-52
        var filterParams = JSON.stringify(self.state.Filters);//RCNG-52

        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/GetPTResult', { method: 'POST', body: filterParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        //var url = Config.ApiBaseUrl + '/api/reeferstatus/GetPTResultsByAssetState?AssetState=' + selectedAssetStates;
        //var request = RCUtils.FetchRequest(url, { method: 'GET', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        
        RCUtils.fetchRetry(request)
            .then(RCUtils.handleResponse)
            .then(response => response.json() as Promise<any>)
            .then(data => {
                self.state.gridApiParams.hideOverlay();
                self.setState({
                    rowData: data.PTResultsData,
                    dropDownVCInfo: data.VesselInfoData,
                    dropDownGeoInfo: data.GeofenceInfoData,
                    //columnDefs: varcolumnDefs,//customColDefs,
                    loading: false
                });
                //$("#globalLoader").hide();
            });
    }
    /* end RCNG-16 */

    renderEmailDialog(gridData: any, colDefs: any, colDefs2: any, formName: string, parentChild: string, functionId: any, widgetId: any, gridApiParams: any, isIncludeRowGroup: boolean) {
        this.props.renderDataToEmailControl(gridData, colDefs, colDefs2, formName, parentChild, functionId, widgetId, gridApiParams, isIncludeRowGroup);
    }

    renderGridPreferenceDialog(functionId: any, widgetId: any, gridApiParams: any, formName: string) {
        this.props.renderDataGridPreferenceControl(functionId, widgetId, gridApiParams, formName);
    }

    renderExportToExcelDialog(functionId: any, widgetId: any, gridApiParams: any, formName: string, gridData: any, colDefs: any, colDefs2: any, parentchild: any) {
        this.props.renderDataGridExportToExcelControl(functionId, widgetId, gridApiParams, formName, gridData, colDefs, colDefs2, parentchild);
    }

    onCellClickedCopy(event) {
        coppiedData = event.value;
    }

    onGridScroll(params: any) {
        $(".context-menu-PTR").hide();
        $("#contextmenu-PTR").hide();
    } 

    ProcessCellForClipboard(params) {
        return Formatters.CopyCommandFormatters(params);
    }

    getContextMenuItems = params => {
        //TODO : after test uncommnet below line
        //RCUtils.HighlightCurrentGridRow(params,"ReeferID",self.state.selectedItems);
        var selectflag = false;
        var selectedCell = params.api.getFocusedCell();
        var selectedRowIndex = selectedCell.rowIndex;
        var currentRow = params.api.getDisplayedRowAtIndex(selectedRowIndex);
        if (currentRow != null && currentRow != "undefined" && !currentRow.group) {
            var currentRowId = currentRow.id;
            coppiedData = params.value;
            var selectedrowNode = params.api.getRowNode(currentRowId);
            var reeferID = selectedrowNode.data.ReeferID;
            params.api.forEachLeafNode((newRowNode, index) => {
                if ((newRowNode.data.ReeferID === reeferID)) {
                    selectedrowNode = newRowNode;
                    return false;
                }
            });
            $.each(self.state.selectedItems, (index, item) => {
                if (item.ReeferID == selectedrowNode.data.ReeferID) {
                    selectflag = true;
                    return false;
                }
            });
            if (!selectflag)
                params.api.deselectAll();
            selectedrowNode.setSelected(true);
        }
        var reeferStatusGridRowsCount = self.props.getReeferStatusGridRows;
        var disableShowinReeferGrid = false;
        if (reeferStatusGridRowsCount > 0) {
            disableShowinReeferGrid = false;
        } else {
            disableShowinReeferGrid = true;
        }
        var result = [
            {
                name: 'Copy Cell',
                action: () => {
                    //this.ptResultContextMenuClick("Copy");
                    var cellContent = this.ProcessCellForClipboard(params);
                    params.api.clipboardService.copyDataToClipboard(cellContent);
                }
            },
            //'copy',
            {
                name: 'Show Pre-Trip Results',
                action: () => {
                    this.popUpGetPTIReport();
                },
            },
            {
                name: 'Show TripWISE Report',
                action: () => {
                    this.popUpGetTWReport();
                },
                cssClasses: UserRights.checkMenuItemVisibilityForPTWidget('206', params, 'ShowTripWISEReport'),                
            },
            {
                name: 'Select in Reefer Grid',
                action: () => {
                    this.showInReeferGrid();
                },
                disabled: disableShowinReeferGrid,
            },          
        ];
        return result;
    };   

    //getContextMenuItems(params: any) {
    //    var  flag = false;
    //    var reeferStatusGridRowsCount = self.props.getReeferStatusGridRows;
    //    if (reeferStatusGridRowsCount > 0) {
    //        $('#liShowinReeferGrid').removeClass('disabled');
    //        $('#liShowinReeferGrid').addClass('enabled');
    //    } else {
    //        $('#liShowinReeferGrid').removeClass('enabled');
    //        $('#liShowinReeferGrid').addClass('disabled');
    //    }
    //    var selected = params.api.getFocusedCell();
    //    var selectedrowNode = params.api.getRowNode(selected.rowIndex);
    //    var tempArray = [];// if sort is clicked save in temp array
    //    params.api.forEachNodeAfterFilterAndSort(function (rowNode, index) {
    //        tempArray.push(rowNode);
    //    });

    //    var resortitem = tempArray[selected.rowIndex];
    //    var reeferid = resortitem.data.ReeferID;
    //    params.api.forEachNodeAfterFilterAndSort(function (NewrowNode, index) {
    //        if ((NewrowNode.data.ReeferID === reeferid)) {
    //            selectedrowNode = NewrowNode;
    //            return false;
    //        }
    //    });

    //    $.each(self.state.selectedItems, function (index, item) {
    //        if (item.ReeferID == selectedrowNode.data.ReeferID) {
    //            flag = true;
    //            return false;
    //        }
    //    });

    //    if (!flag)
    //        params.api.deselectAll();
        
    //    //$(".context-menu-PTR").show(); $("#contextmenu-PTR").show();
    //    Excel.preventDefault();
    //    params.api.gridOptionsWrapper.gridOptions.api.selectNode(selectedrowNode, true);

    //    $(document).contextmenu(function (e) {
    //        var divmenuwidth = 390;
    //        var offset = $("#PTR-grid .ag-column-hover").offset();
    //        if ((typeof (offset) != 'undefined') && offset != null) {
    //            if (offset.left > 400) {
    //                divmenuwidth = 390;
    //            } else if (offset.left > 890) {
    //                divmenuwidth = 690;
    //            } else {
    //                divmenuwidth = 40;
    //            }
    //        }
    //        /// var relativeX = (e.pageX - offset.left);
    //        var relativeY = (e.pageY - offset.top + 50);
    //        var relativeX = e.pageX - divmenuwidth;

    //        if (relativeX > ($(window).width() - (divmenuwidth + 5))) {
    //            relativeX = relativeX - (divmenuwidth + 5);
    //        }
    //        var height = $(window).height() - 200;
    //        var halfheight = ($(window).height()) / 2;
    //        if (height < relativeY) {
    //            relativeY = (relativeY - halfheight) + 20;
    //        }
    //        $(".context-menu-PTR").css({
    //            top: relativeY + "px",
    //            left: relativeX + "px",
    //            position: "absolute"
    //        });
    //        $("#contextmenu-PTR").show();
    //        $(".context-menu-PTR").show();

    //    });


    //    $("#PTR-grid .ag-cell").unbind("contextmenu-PTR");
    //    $("#PTR-grid .ag-cell").bind('contextmenu-PTR', function (e) {

    //        var flag = false;
    //        var selected = params.api.getFocusedCell();
    //        var selectedrowNode = null;// params.api.getRowNode(selected.rowIndex);
    //        var tempArray = [];// if sort is clicked save in temp array
    //        params.api.forEachNodeAfterFilterAndSort(function (rowNode, index) {
    //            tempArray.push(rowNode);
    //        });
    //        var resortitem = tempArray[selected.rowIndex];
    //        var sortflage = false;
    //        var reeferid = resortitem.data.ReeferID;
    //        params.api.forEachNodeAfterFilterAndSort(function (NewrowNode, index) {
    //            if ((NewrowNode.data.ReeferID === reeferid)) {
    //                selectedrowNode = NewrowNode;
    //                return false;
    //            }
    //        });
    //        $.each(self.state.selectedItems, function (index, item) {
    //            if (item.ReeferID == selectedrowNode.data.ReeferID) {
    //                flag = true;
    //                return false;
    //            }
    //        });
    //        if (!flag)
    //            params.api.deselectAll();
    //        params.api.gridOptionsWrapper.gridOptions.api.selectNode(selectedrowNode, true);
    //        var reSized = self.props.isResizeClicked;
    //        if (JSON.stringify(reSized) === 'false') {
    //            var divmenuwidth = 180;
    //        } else {
    //            var divmenuwidth = 20;
    //        }
    //        var divmenuwidth = 390;
    //        var offset = $("#PTR-grid .ag-column-hover").offset();
    //        if ((typeof (offset) != 'undefined') && offset != null) {
    //            if (offset.left > 400) {
    //                divmenuwidth = 390;
    //            } else {
    //                divmenuwidth = 40;
    //            }
    //        }
    //        /// var relativeX = (e.pageX - offset.left);
    //        var relativeY = (e.pageY - offset.top);
    //        //var relativeX = e.pageX - divmenuwidth;
    //        var relativeX = (e.pageX - offset.left);

    //        if (relativeX > ($(window).width() - (divmenuwidth + 5))) {
    //            relativeX = relativeX - (divmenuwidth + 5);
    //        }
    //        var height = $(window).height();
    //        var halfheight = ($(window).height()) / 2;

    //        if (JSON.stringify(reSized) === 'false') {
    //            // click on below window half height make to Y top to static value 140px
    //            if (relativeY > 140) {
    //                relativeY = 140;
    //            }
    //        } else {
    //            var height = $(window).height() - 200;
    //            var halfheight = ($(window).height()) / 2;
    //            if ((window as any).clipboardData) {
    //                if (height < relativeY + 60) {
    //                    //if IE Browser 
    //                    relativeY = (relativeY - 150);
    //                }
    //            }
    //            else if (height < relativeY + 378) {
    //                relativeY = (relativeY - 135);
    //            }
    //        }
    //        $(".context-menu").css({
    //            top: relativeY + "px",
    //            left: relativeX + "px",
    //            position: "absolute"
    //        });
    //        $("#contextmenu-PTR").show();
    //        $(".context-menu-PTR").show();
    //        e.preventDefault();
    //        return false;
    //    });

    //    $(document).contextmenu(function () {
    //        return false;
    //    });

    //    $(document).bind('contextmenu-PTR click', function () {
    //        $(".context-menu-PTR").hide();
    //    });

    //    $('.context-menu-PTR').bind('contextmenu-PTR', function () {
    //        return false;
    //    });
    //    $('.context-menu-PTR').on('click', 'li', function () {
    //        $(".context-menu-PTR").hide();
    //    });
    //}

    disableDropDownMenuCollapse() {
        $('.disable-collapse').addClass('open');
    };

    onSelectionChanged(params: any) {
        $("#contextmenu-PTR").show();
        //var rights = self.props.loggedInUserData.User.Customer.Rights;
        var selectedReeferData = [];
        var selectedRows = params.api.getSelectedRows();
        selectedRows.forEach(function (selectedRow, index) {
            selectedReeferData.push(selectedRow);
        });

        self.setState({
            selectedItems: selectedReeferData,
            isChangeDeforstInterval: false,
            pretripCmd: null,
            modelTitle: '',
            popUpHtml: ''
        });
    }


    VesselChange(event: React.FormEvent<HTMLSelectElement>) {
        var vesselID: string = event.currentTarget.value;
        var index = event.currentTarget.selectedIndex;
        //var vesselName: string = event.currentTarget[index].text;
        this.setState({
            selectedVesselID: parseInt(vesselID)
        });
    }

    GeofenceChange(event) {
        if (event != null) {
            var geofID: string = event.value;
            var geofName: string = event.label;
            this.setState({
                selectedGoeID: parseInt(geofID),
                selectedGoeTag: geofName
            });
        }
        else {
            this.setState({
                selectedGoeID: null,
                selectedGoeTag: null
            });
        }
    }

    handleCheck(e) {
        $('.apply-ptresults').addClass('open');
    }

    ptResultContextMenuClick(this: any, item: any) {
        switch (item) {
            case "Copy": this.ptResultDetailsCopyAction();
                break;
        }
    }

    ptResultDetailsCopyAction() {
        //var result = this.copyToClipboard(coppiedData);
        self.state.gridApiParams.clipboardService.copyDataToClipboard(coppiedData);
    }
    showInReeferGrid() {
        var reeferData = self.state.selectedItems;
        if (reeferData != undefined && reeferData != null) {
            var reeferStatusGridRowsCount = this.props.getReeferStatusGridRows;
            if (reeferStatusGridRowsCount > 0) {
                ReeferStatusGrid.ShowCurrentPTRSelectedReefer(reeferData[0]);
            }
        }

    }

    popUpGetPTIReport() {
        var reeferData = self.state.selectedItems;
        if (reeferData != undefined && reeferData != null) {
            $('#globalLoader').show();
            var url = Config.ApiBaseUrl + '/api/reeferstatus/GetPTRReport?containerID=' + reeferData[0].ReeferID;
            var request = RCUtils.FetchRequest(url, { method: 'GET', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
            fetch(request)
                .then(RCUtils.handleError)
                .then(response => response.json())
                .then(result => {
                    this.setState({ PTReport: result }, () => { self.props.getCommandPopupPTReport(this.state.PTReport); });
                    this.setState({ ReportReeferId: reeferData[0].ReeferID }, () => { self.props.getCommandPopupReportReeferId(this.state.ReportReeferId); });
                    $('#globalLoader').hide();
                    if (this.state.PTReport == null || this.state.PTReport == '')
                        PopupWindow.showErrorMessage("Alert", "No pre-trip reports have been collected for this reefer. Execute the ‘Get Pre-Trip Results’ command to collect the latest available report.");
                    else {
                        this.setState({ modelTitle: 'Pre-Trip Report', popUpHtml: <div dangerouslySetInnerHTML={{ __html: this.state.PTReport }} /> }, () => { self.props.getCommandPopupTitleReport(this.state.modelTitle); self.props.getCommandPopupContentReport(this.state.popUpHtml); });
                        $('#btnTriggerReport').click();
                    }
                });
        }
    }

    popUpGetTWReport() {
        var reeferData = self.state.selectedItems;
        if (reeferData != undefined && reeferData != null) {
            $('#globalLoader').show();
            var url = Config.ApiBaseUrl + '/api/reeferstatus/GetTripWISEReport?containerID=' + reeferData[0].ReeferID;
            var request = RCUtils.FetchRequest(url, { method: 'GET', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
            fetch(request)
                .then(RCUtils.handleError)
                .then(response => response.json())
                .then(result => {
                    this.setState({ TWReport: result, ReportReeferId: reeferData[0].ReeferID }, () => { this.bindTWReport(); });
                });
        }
    }
    bindTWReport() {
        self.props.getCommandPopupTWReport(this.state.TWReport);
        self.props.getCommandPopupReportReeferId(this.state.ReportReeferId);
        $('#globalLoader').hide();
        if (this.state.TWReport == null || this.state.TWReport == '')
            PopupWindow.showErrorMessage("Alert", "No TripWISE reports have been collected for this reefer. Execute the ‘Get TripWISE Report’ command to collect the latest available report.");
        else {
            this.setState({ modelTitle: 'TripWISE Report', popUpHtml: <div dangerouslySetInnerHTML={{ __html: this.state.TWReport }} /> }, () => { self.props.getCommandPopupTitleReport(this.state.modelTitle); self.props.getCommandPopupContentReport(this.state.popUpHtml); });
            $('#btnTriggerReportTW').click();
        }
    }


    //copyToClipboard(text) {
    //    if ((window as any).clipboardData && (window as any).clipboardData.setData) {
    //        return (window as any).clipboardData.setData("Text", text);

    //    } else if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
    //        var textarea = document.createElement("textarea");
    //        textarea.textContent = text;
    //        textarea.style.position = "fixed";
    //        document.body.appendChild(textarea);
    //        textarea.select();
    //        try {
    //            return document.execCommand("copy");
    //        } catch (ex) {
    //            return false;
    //        } finally {
    //            document.body.removeChild(textarea);
    //        }
    //    }
    //}
    
  
    public render() {
        var groupRowRendererParams: any = {
            innerRenderer: this.groupRowInnerRenderer
        };
        var excelStyles: any = [
            {
                id: 'bigInt',
                dataType: 'string',
                font: {
                    size: 12
                },

            },
            {
                id: 'myExcelStyle',
                font: {
                    size: 12,
                }
            },
            {
                id: 'header',
                font: {
                    size: 14,
                },
            },
        ];

        var GeofenceDefinitions = this.state.dropDownGeoInfo;

        if (GeofenceDefinitions != undefined && GeofenceDefinitions != null && GeofenceDefinitions.length > 0) {
            var GeofenceDefinationOptions = GeofenceDefinitions.map(function (geofence) {
                return (
                    { value: geofence.FenceID, label: geofence.Tag }
                );
            });
        }

        return <div>
            <div className='dashboard-GridToolbar'>
                <GridPTIToolBar
                    refreshGrid={this.refreshGrid.bind(this)}
                    gridData={this.state.rowData}
                    colDefs={this.state.columnDefs}
                    colDefs2={columnDefs2}
                    parentchild={"C"}
                    formName={"PTResultGrid"}
                    gridApiParams={this.state.gridApiParams}
                    searchFilters={this.state.Filters}
                    sourceFrom='Dashboard'
                    dashboardPreferenceId = {this.props.dashboardPreferenceId}
                    isReadOnly={this.props.isReadOnly}
                    revisionNum={this.props.revisionNum}
                    dashboardWidgetsSearch={this.props.dashboardWidgetsSearch}
                    validateRevisionNum={this.props.validateRevisionNum.bind(this)}
                    renderEmailDialog={this.renderEmailDialog.bind(this)}
                    renderGridPreferenceDialog={this.renderGridPreferenceDialog.bind(this)}
                    renderExportToExcelDialog={this.renderExportToExcelDialog.bind(this)}
                />
            </div>
            <div className="apply-ptresults">
                <button className="btn btn-outline-secondary dropdown-toggle btn-sm" type="button" data-bs-auto-close="false" data-bs-toggle="dropdown" data-bs-display="static" aria-expanded="false">
                    <span className="fa-sharp fa-solid fa-filter"></span>

                    <span className='mx-1'> Apply filters </span>
              
                </button>
            
                <ul id="PTRPopUP" className="dropdown-menu dropdown-menu-end disable-collapse">
                    <li>
                        <div className="row mt-2" onClick={this.handleCheck.bind(this)}>
                            <div className="col-md-2 pe-0 text-md-end">
                                <label className='col-form-label'>From:</label>
                            </div>
                            <div className="col-md-10">
                                <div className='date-picker'>
                                    <DatePicker
                                            portalId="root-portal-From"
                                            selected={new Date(this.state.Filters.FromDate)}
                                            maxDate={new Date(this.state.PreferenceDTTM)}
                                            onChange={this.FromDateChange.bind(this)}
                                            timeInputLabel="Time:"
                                            showYearDropdown
                                            yearDropdownItemNumber={5}
                                            dateFormat="MM/dd/yyyy hh:mm aa"
                                            showTimeInput  
                                            className="PTI-datetime"                        
                                        />
                                  
                                </div>
                            </div>
                        </div>
                        <div className="row mt-2 " onClick={this.handleCheck.bind(this)}>
                            <div className="col-md-2 pe-0 text-md-end">
                                <label className='col-form-label'>To:</label>
                            </div>
                            <div className="col-md-10">
                                <div className='date-picker'>
                                 
                                    <DatePicker
                                            portalId="root-portal-From"
                                            selected={new Date(this.state.Filters.ToDate)}
                                            maxDate={new Date(this.state.PreferenceDTTM)}
                                            onChange={this.ToDateChange.bind(this)}
                                            timeInputLabel="Time:"
                                            showYearDropdown
                                            yearDropdownItemNumber={5}
                                            dateFormat="MM/dd/yyyy hh:mm aa"
                                            showTimeInput  
                                            className="PTI-datetime"                        
                                        />
                                  
                                </div>
                            </div>
                        </div>
                        <div className="row mt-2 " onClick={this.handleCheck.bind(this)}>
                            <div className="col-md-12 grid-select-control">
                                <Select
                                    value={this.state.selectedGoeID}
                                    onChange={this.GeofenceChange.bind(this)}
                                    options={GeofenceDefinationOptions}
                                    placeholder="Geofence"
                                    removeSelected={this.state.isClearable}
                                />
                            </div>
                        </div>
                        <div className="row mt-2 " onClick={this.handleCheck.bind(this)}>
                            <div className="col-md-12">
                                <select id='vcOption' className='form-select' onChange={e => this.VesselChange(e)} value={this.state.selectedVesselID}>
                                    <option value="0">Vessel Name</option>
                                    {
                                        this.state.dropDownVCInfo.map((item, index) =>
                                            <option key={index} value={item.VesselId}>{item.VesselNm}</option>
                                        )}
                                </select></div>
                        </div>
                        <div className="row mt-2 ">
                            <div className="col-md-12">
                                <div className='float-end'>
                                    <button type='button' id='btn_Search' onClick={this.getPTResultDetails.bind(this)} className='btn btn-primary'>Search</button>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <div className="ag-theme-fresh PTRGrid-height-overflow" id='PTR-grid'>
                <AgGridReact
                    columnDefs={this.state.columnDefs}
                    rowData={this.state.rowData}
                    onGridReady={this.onGridReady}
                    animateRows={true}
                    rowGroupPanelShow={this.state.rowGroupPanelShow}
                    autoGroupColumnDef={this.state.autoGroupColumnDef}
                    suppressDragLeaveHidesColumns={true}
                    suppressMakeColumnVisibleAfterUnGroup={true}
                    pagination={true}
                    groupRowRendererParams={groupRowRendererParams}
                    //groupRowInnerRenderer={this.groupRowInnerRenderer}
                    defaultGroupOrderComparator={
                        function (nodeA, nodeB) {
                            var AnodeIsNumber = Number(nodeA.key);
                            var BnodeIsNumber = Number(nodeB.key);
                            var AnodeIsString = String(nodeA.key);
                            var BnodeIsString = String(nodeB.key);

                            if (!isNaN(AnodeIsNumber) && !isNaN(BnodeIsNumber)) {
                                return AnodeIsNumber - BnodeIsNumber;
                            } else {
                                return AnodeIsString.localeCompare(BnodeIsString);
                            }
                        }
                    }
                    groupDisplayType='groupRows'
                    paginationPageSize={this.state.pageSize}
                    excelStyles={excelStyles}
                    rowSelection={'single'}
                    accentedSort={true}
                    rowDeselection={true}
                    onPaginationChanged={this.onPaginationPageLoaded}
                    navigateToNextCell={this.navigateToNextCell}
                    overlayLoadingTemplate={this.state.overlayLoadingTemplate}
                    processCellForClipboard={this.ProcessCellForClipboard}
                    onSelectionChanged={this.onSelectionChanged}
                    allowContextMenuWithControlKey={true}
                    getContextMenuItems={this.getContextMenuItems}
                    onBodyScroll={this.onGridScroll}>
                </AgGridReact>
            </div>
            <div className='pageSizePTI hide'>
                <span className='pageSize-lable'>Page Size:</span>
                <select onChange={e => this.pageSizeChange(e)} value={this.state.pageSize}>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="75">75</option>
                    <option value="100">100</option>
                    <option value="250">250</option>
                </select>
            </div>
        </div>;
    }
}



